import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getWalletDirection } from '../../redux/actions/wallet.actions'
import { MultiplePaymentsContainer } from './multiple-payments-container'
import { SinglePaymentContainer } from './single-payment-container'
import { Button } from '../../shared/button/button'

export const PaymentsContainer = ({ user, credentials, wallet }) => {
  const [transactionType, setTransactionType] = useState('single-transaction')
  const {
    walletDirection: { polygonAddress, tronAddress },
  } = useSelector((state) => state.wallets)

  const dispatch = useDispatch()

  const stylesSelectedButton = {
    backgroundColor: 'transparent !important',
    color: '#0197F6 !important',
    borderColor: '#0197F6 !important',
  }

  function handleShowSingleTransaction() {
    setTransactionType('single-transaction')
  }

  const handleShowMassPayments = () => {
    setTransactionType('mass-payments')
  }

  useEffect(() => {
    if (credentials?.id) {
      dispatch(getWalletDirection(credentials?.id))
    }
  }, [dispatch, credentials?.id])

  return (
    <Box display={'flex'} flexDirection={'column'} gap={'24px'}>
      <Box display={'flex'} width={'100%'}>
        <Button
          label={'Single payment'}
          onClick={handleShowSingleTransaction}
          buttonStyles={{
            borderRadius: '8px 0 0 8px !important',
            ...(transactionType === 'single-transaction' &&
              stylesSelectedButton),
          }}
          containerStyles={{
            width: '100%',
          }}
          endIcon={'ArrowBendUpRight'}
        />
        <Button
          label={'Multiple payments'}
          onClick={handleShowMassPayments}
          buttonStyles={{
            borderRadius: '0 8px 8px 0 !important',
            ...(transactionType === 'mass-payments' && stylesSelectedButton),
          }}
          containerStyles={{
            width: '100%',
          }}
          endIcon={'ArrowBendDoubleUpRight'}
        />
      </Box>
      {transactionType === 'mass-payments' && (
        <MultiplePaymentsContainer user={user} />
      )}
      {transactionType === 'single-transaction' && (
        <SinglePaymentContainer
          user={user}
          shareWallet={wallet?.secp256k1_share}
          clientApiKey={credentials?.clientApiKey}
          polygonAddress={polygonAddress}
          tronAddress={tronAddress}
        />
      )}
    </Box>
  )
}
